import { makeStyles } from "@material-ui/styles";

const drawerWidth = 240;

export default makeStyles(theme => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundColor: "#ffffff",
    borderRight: "1px solid #eef1f5",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-thumb": { backgroundColor: "#d7dde6", borderRadius: 6 },
    "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
  },
  drawerClose: {
    backgroundColor: "#ffffff",
    borderRight: "1px solid #eef1f5",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 40,
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth,
    },
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-thumb": { backgroundColor: "#d7dde6", borderRadius: 6 },
    "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  sidebarList: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  sectionLabel: {
    margin: theme.spacing(1, 0, 0.5, 0),
    paddingLeft: 22,
    color: "#9aa6b6",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  skeletonRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    margin: "2px 12px",
    padding: "9px 12px",
  },
  skeletonText: {
    borderRadius: 6,
  },
  mobileBackButton: {
    marginTop: theme.spacing(0.5),
    marginLeft: 18,
    [theme.breakpoints.only("sm")]: {
      marginTop: theme.spacing(0.625),
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));
